<template>
  <modal
    width="620px"
    :title="t('Custom Conversions Sending')"
    @close="close"
    :read-article-url="`https://docs.bemob.com/${locale}/custom-conversions`"
  >
    <template #default>
      <div class="form-container">
        <p v-html="t('The option of custom conversions sending works if you have at least one custom conversion configured in your account. If you don’t track custom conversions, leave <b>All</b> selection as default choice.')" />
        <p>
          {{ t('The conversions passing to the traffic source doesn’t depend on this option. All conversions received in BeMob will be passed to your traffic source.') }}
        </p>
        <p v-html="t('More details see in our <a href={0} target=`_blank`><b>guide</b></a>.', [`https://docs.bemob.com/${locale}/custom-conversions`])" />
      </div>
    </template>
    <template #footer>
      <section class="justify-end" style="display: flex;">
        <ui-button
          button-style="accent"
          icon="fas fa-check"
          :text="t('Ok')"
          @click="close"
        ></ui-button>
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';

const emit = defineEmits<{
  close: [];
}>();

const { t, locale } = useI18n();

const close = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>

</style>
